module.exports = __webpack_public_path__ + "img/graph-blue.ddc20a6f.png";